<template>
  <v-card flat class="auth-home--header" color="transparent">
    <v-row align="center">
      <v-col cols="12">
        <v-toolbar flat color="grey lighten-2" class="px-2">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn small fab text color="secondary" v-on="on" :loading="isLoading" @click="reset">
                <v-icon small>fal fa-redo</v-icon>
              </v-btn>
            </template>
            <span>リセットする</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn small fab text v-on="on" :disabled="isLoading" @click="search">
                <v-icon small>fal fa-search</v-icon>
              </v-btn>
            </template>
            <span>検索する</span>
          </v-tooltip>
          <v-text-field solo flat hide-details clearable
            v-model="form.primary"
            background-color="transparent"
            label="かな or 名前"
            clear-icon="fal fa-times"
            @keypress.enter.prevent="search"
          />
          <v-menu bottom right offset-y
            :close-on-content-click="false">
            <template v-slot:activator="{ on }">
              <v-btn fab text small
                v-on="on"
                class="mr-2"><v-icon small>fa-caret-down</v-icon>
              </v-btn>
            </template>
            <v-card>
              <v-card-text>
                <v-row dense>
                  <v-col cols="12">
                    <v-select
                      v-model="form.country"
                      label="留学国"
                      :items="getNationItems"
                      @change="search(1)"
                    />
                  </v-col>
                </v-row>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn depressed
                  color="secondary"
                  @click="search">検索する</v-btn>
              </v-card-actions>
            </v-card>
          </v-menu>
          <v-btn-toggle v-if="$vuetify.breakpoint.smAndUp" mandatory class="grey lighten-3" v-model="form.status" @change="search(1)">
            <v-btn :text="form.status !== 1" :depressed="form.status === 1" color="secondary white--text" :value="1">出発前</v-btn>
            <v-btn :text="form.status !== 2" :depressed="form.status === 2" color="secondary white--text" :value="2">出発後</v-btn>
          </v-btn-toggle>
        </v-toolbar>
      </v-col>
    </v-row>
    <v-row dense align="center" class="mt-2">
      <v-col cols="6" sm="3" md="2" class="fm-in">
        <p class="caption grey--text text--darken-2">表示数</p>
        <v-btn-toggle dense mandatory class="transparent" v-model="form.limit" @change="search(1)">
          <v-btn :text="form.limit !== '10'" :depressed="form.limit === '10'" color="secondary white--text" value="10">10</v-btn>
          <v-btn :text="form.limit !== '50'" :depressed="form.limit === '50'" color="secondary white--text" value="50">50</v-btn>
          <v-btn :text="form.limit !== '100'" :depressed="form.limit === '100'" color="secondary white--text" value="100">100</v-btn>
        </v-btn-toggle>
      </v-col>
      <v-col cols="6" v-if="$vuetify.breakpoint.xsOnly" class="pl-5 fm-in">
        <p class="caption grey--text text--darken-2">出発</p>
        <v-btn-toggle dense mandatory class="grey lighten-3" v-model="form.status" @change="search(1)">
          <v-btn :text="form.status !== 1" :depressed="form.status === 1" color="secondary white--text" :value="1">前</v-btn>
          <v-btn :text="form.status !== 2" :depressed="form.status === 2" color="secondary white--text" :value="2">後</v-btn>
        </v-btn-toggle>
      </v-col>
      <v-spacer></v-spacer>
      <v-col v-if="!isLoading" cols="4" sm="2">
        <span class="body-2 text-xs-center">{{ printPageInfo }}</span>
      </v-col>
      <v-spacer v-if="$vuetify.breakpoint.xsOnly" />
      <v-col cols="2" sm="1" class="py-2">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn icon color="secondary" v-on="on" :disabled="isLoading || !isAccessiblePrev" @click="prev">
              <v-icon small>fal fa-chevron-left</v-icon>
            </v-btn>
          </template>
          <span>前へ</span>
        </v-tooltip>
      </v-col>
      <v-col cols="2" sm="1" class="py-2">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn icon color="secondary" v-on="on" :disabled="isLoading || !isAccessibleNext" @click="next">
              <v-icon small>fal fa-chevron-right</v-icon>
            </v-btn>
          </template>
          <span>次へ</span>
        </v-tooltip>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
const DEF = {
  FORM: {
    primary: '',
    limit: '10',
    page: 1,
    status: 1,
    size: 99,
    country: ''
  }
}
export default {
  name: 'authorHomeToolbars',
  props: [
    'status',
    'authors',
    'arrangers'
  ],
  data () {
    return {
      form: {
        primary: DEF.FORM.primary,
        status: DEF.FORM.status,
        limit: DEF.FORM.limit,
        page: DEF.FORM.page,
        size: DEF.FORM.size,
        country: DEF.FORM.country
      }
    }
  },
  created () {
    this.init()
  },
  methods: {
    init: function () {
      this.search()
    },
    search: function (page) {
      if (this.$props.status && !this.$props.status.loading) {
        this.$nextTick(() => {
          let fm = this.getForm(page)
          this.$emit('emit', {
            action: 'get',
            data: fm
          })
        })
      }
    },
    reset: function () {
      this.$set(this, 'form', JSON.parse(JSON.stringify(DEF.FORM)))
      this.search(1)
    },
    prev: function () {
      let num = this.form.page
      if (num !== 1) {
        this.$set(this.form, 'page', num - 1)
        this.search(num - 1)
      }
    },
    next: function () {
      let num = this.form.page
      if (num !== this.form.size) {
        this.$set(this.form, 'page', num + 1)
        this.search(num + 1)
      }
    },
    count: function (size) {
      this.$set(this.form, 'size', size)
    },
    getForm: function (page) {
      return {
        primary: this.form.primary,
        status: this.form.status,
        country: this.form.country,
        limit: {
          offset: (page != null && isFinite(page)) ? page : this.form.page,
          size: parseInt(this.form.limit)
        },
        page: (page != null && isFinite(page)) ? page : this.form.page
      }
    }
  },
  computed: {
    isLoading () {
      return (this.$props.status && this.$props.status.loading)
    },
    isAccessibleNext () {
      return ((this.form.size - this.form.page * this.form.limit) > 0)
    },
    isAccessiblePrev () {
      return ((this.form.page - 1) > 0)
    },
    getNationItems () {
      return [
        {
          value: '',
          text: '選択なし'
        }, ...Object.keys(this.$mango.nations).filter(key => {
          return key !== 'JP'
        }).map(key => { return { value: key, text: this.$mango.nations[key] } })
      ]
    },
    printFormStatus () {
      return this.form.status ? '出発済み' : '出発前'
    },
    printPageInfo () {
      let limit = parseInt(this.form.limit)
      let num = this.form.page
      let st = limit * (num - 1) + 1
      let ed = Math.min(limit * num, this.form.size)
      return `${st} - ${ed} / ${this.form.size}`
    }
  }
}
</script>

<style lang="scss">
.auth-home--header {
  .fm-in {
    position: relative;
    .caption {
      position: absolute;
      top: -1.2em;
    }
  }
}
</style>
